define('model/ClassesModel',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    /**
     * Classes time info model
     *
     * @class ClassesModel
     */
    return Backbone.Model.extend({

        defaults: {
            id: '',
            date: '',
            provider_id: '',
            from: '',
            to: ''
        }

    });

});
